// FIXME: react-native-reanimated issue, see https://github.com/software-mansion/react-native-reanimated/issues/3355
if (typeof window !== 'undefined') {
  // @ts-ignore
  window._frameTimestamp = null;
}
